export const LITBLANGS = {
	EN: "en",
	MS: "ms",
	FR: "fr",
	ES: "es",
	DE: "de",
	IT: "it",
	PT: "pt",
	JA: "ja",
	RU: "ru",
	NL: "nl",
	AR: "ar",
	NO: "no",
	DA: "da",
	SV: "sv",
	KO: "ko",
	FI: "fi",
	HE: "he",
	TR: "tr",
	PL: "pl",
	CZ: "cz",
	GR: "gr",
	HR: "hr",
	RO: "ro",
	HU: "hu",
	RE: "re",
};
